// extracted by mini-css-extract-plugin
module.exports = {"tablestyle":"table_tablestyle__2GZhe"};